import {useParams} from "react-router-dom";
import {getBlog, baseurl, getProduct} from "../services/services";
import React, {useEffect, useState} from "react";
import {LinearProgress} from "@mui/material";
import {Swiper, SwiperSlide} from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import {NumericFormat} from "react-number-format";

const Singleproduct = () => {
    let {PID} = useParams()

    const [data, setData] = useState(false)

    const getdata = async () => {
        const options = {


            params: {id: PID}
        };
        const res = await getProduct(options)
        if (res) {

            setData(res.data)
            console.log(res.data);
        }
    }

    useEffect(() => {
        getdata().then()
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    let content
    if (data !== false) {
        const images = JSON.parse(data.product.images);
        content =
            <div className='columns p-3 is-multiline my-4 wdith100  clrtwoborder padtopmobile '>
                <div className='column is-12'>
                    <h1 className='is-size-4-desktop'>
                        {data.product.title}


                        <span className='clrtwotext is-float-left'>
                            <NumericFormat displayType='text' prefix={'$'} value={data.product.price}  thousandSeparator="," />
                        </span>
                    </h1>
                </div>



                <div className='column is-12 has-text-centered'>
                    <img src={`${baseurl}/${data.product.image}`} alt=""/>


                </div>

                <div className='column is-12 has-text-centered'>
                <span className='clrone has-text-white borderrad1   kook is-size-6 ml-5 p-1 my-auto'
                      >
                                 {data.product.description}
                              </span>
                </div>


                <div className='column is-12'>

                    <Swiper
                        modules={[Navigation, Pagination]}
                        navigation
                        pagination={{ clickable: true }}
                        spaceBetween={10}
                        slidesPerView={1}
                        className='wdith100'
                    >
                        {images.map((image, index) => (
                            <SwiperSlide key={index}>
                                <img
                                    src={`${baseurl}/${image}`}
                                    alt={`Product image ${index + 1}`}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>

                <div className='column is-12'>
                  <h4 className='has-text-white is-size-5'>
                      ویژگی های فنی
                  </h4>
                    <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth  ">
                        <tbody>
                        {data.attributes.map((attribute, index) => (
                            <tr  key={index}>
                                <td className='clronetext'>{attribute.key}</td>
                                <td className='clronetext'>{attribute.value}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

            </div>

    } else {
        content = <div className='column is-12'>
            <LinearProgress variant='indeterminate' color='secondary' sx={{
                '&.MuiLinearProgress-root': {
                    backgroundColor: '#00A651'
                }

            }}/>
        </div>
    }


    return (
        <>
            <main className='wdith100'>

                <div className='columns navpadend150 navpadstart150 mx-0  my-6 pt-3 has-text-white '>


                    <div className='column is-12'>
                        {
                            content
                        }
                    </div>




                </div>
            </main>


        </>
    )
}
export default Singleproduct;